const _global = window as any;

const APP_NAME = 'Bybit-us';

const sensorsInstance = _global?.sensors;

sensorsInstance?.registerPage?.({
  app_name: APP_NAME,
});

export const sensors = sensorsInstance;

export default {
  track: (event: string, options: any) => {
    _global?.sensors?.track?.(event, options);
  },
};
